var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.629,
    height: 39.319,
    viewBox: "0 0 39.629 39.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6147",
    "data-name": "Group 6147",
    transform: "translate(-1.25 -1.744)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 10.295,
    cy: 10.295,
    r: 10.295,
    transform: "translate(10.141 1.744)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47423",
    "data-name": "Path 47423",
    d: "M25.994,29.8l-1.419-4.749a5.146,5.146,0,0,1,.268-3.65l3.246-6.962a34.672,34.672,0,0,0-7.652-.831c-6.218,0-11.724,1.556-15.142,3.886C2.688,19.27,1.25,21.53,1.25,23.9v2.714A3.177,3.177,0,0,0,4.432,29.8Z",
    transform: "translate(0 10.342)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47424",
    "data-name": "Path 47424",
    d: "M28.936,19.031a3.28,3.28,0,0,0-1.584-4.354l-4.011-1.87a3.274,3.274,0,0,0-4.352,1.585L14.9,23.155a3.282,3.282,0,0,0-.17,2.321l1.556,5.209a1.406,1.406,0,0,0,1.9.885l4.99-2.155a3.276,3.276,0,0,0,1.67-1.623Z",
    transform: "translate(11.636 9.378)",
    fill: "#4165f6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAccount);
export default __webpack_public_path__ + "static/media/editAccount.22f9fd78b3293d1c824f48b997c461f1.svg";
export { ForwardRef as ReactComponent };